// removed by extract-text-webpack-plugin
module.exports = {"digitWrapper":"purify_Password__digitWrapper___3UWgy","digits":"purify_Password__digits___3LWfZ"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/shared/Password/Password.scss
// module id = 225
// module chunks = 0